<template>
  <div class="bg-white p-8">
    <el-dialog
      title=""
      :visible.sync="centerDialogVisibleg"
      :before-close="handleclose"
      width="30%"
      center
    >
      <template slot="title">
        <h2 class="text-lg text-left text-white font-semibold">Add Authors</h2>
      </template>
      <el-form :model="form" :rules="rules" ref="form">
        <div>
          <div class="mb-6">
            <lable>Author Name</lable>
            <el-form-item
              prop="authorName"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' authorName cannot be Empty.',

                  trigger: 'blur',
                },
                {
                  pattern: /^[a-zA-Z ]*$/,
                  message: ' name must Contain Alpahbets only',

                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                placeholder="Enter"
                v-model="form.authorName"
                class="rounded-none mt-2 w-full"
              ></el-input>
            </el-form-item>
          </div>
          <div class="mb-3">
            <lable>Phone No.</lable>
            <el-form-item
              prop="authorNumber"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' AuthorNumber cannot be Empty.',
                  trigger: 'blur',
                },
                {
                  pattern: /^\d*$/,
                  message: ' Mobile must be a number.',
                  trigger: blur,
                },
              ]"
            >
              <el-input
                placeholder="Enter"
                v-model="form.authorNumber"
                type="number"
                class="rounded-none mt-2 w-full"
              ></el-input>
            </el-form-item>
          </div>
          <div class="mb-3">
            <lable>Email</lable>
            <el-form-item
              prop="authorEmail"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' Email cannot be Empty.',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                placeholder="Enter"
                v-model="form.authorEmail"
                class="rounded-none mt-2 w-full"
                type="email"
              ></el-input>
            </el-form-item>
          </div>
          <div class="mb-3">
            <lable>About Me</lable>
            <el-form-item
              prop="authorAbout"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' AuthorNumber cannot be Empty.',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                type="textarea"
                :rows="2"
                class="mt-2 w-full"
                placeholder="Please input"
                v-model="form.authorAbout"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="mb-3">
            <lable>LinkedIn</lable>
            <el-form-item
              prop="socialLinkedin"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' socialLinkedin cannot be Empty.',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                placeholder="Enter"
                v-model="form.socialLinkedin"
                class="rounded-none mt-2 w-full"
              ></el-input>
            </el-form-item>
          </div>
          <div class="mb-3">
            <lable>Facebook</lable>
            <el-form-item
              prop="socialFacebook"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' socialFacebook cannot be Empty.',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                placeholder="Enter"
                v-model="form.socialFacebook"
                class="rounded-none mt-2 w-full"
              ></el-input>
            </el-form-item>
          </div>
          <div class="mb-3">
            <el-form-item
              prop="socialTwitter"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' socialTwitter cannot be Empty.',
                  trigger: 'blur',
                },
              ]"
            >
              <lable>Twitter</lable>
              <el-input
                placeholder="Enter"
                v-model="form.socialTwitter"
                class="rounded-none mt-2 w-full"
              ></el-input>
            </el-form-item>
          </div>
          <div class="mb-3">
            <lable>Youtube</lable>
            <el-form-item
              prop="socialYoutube"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' socialYoutube cannot be Empty.',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                placeholder="Enter"
                v-model="form.socialYoutube"
                class="rounded-none mt-2 w-full"
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex mt-6 justify-center">
            <vs-button
              variant="primary"
              class="rounded-lg bg-primary border-0 text-white font-semibold py-3 px-8 sm-fsize14"
              @click="handleCategoryError('form')"
            >
              Submit
            </vs-button>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <div class="flex justify-end w-full">
      <div class="flex items-center gap-2">
        <vs-button
          variant="primary"
          @click="centerDialogVisibleg = true"
          class="rounded-lg bg-primary border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-8 sm-fsize14"
        >
          Add
        </vs-button>
      </div>
    </div>
    <div class="mt-4">
      <div class="relative">
        <el-form-item
          prop="name"
          class=""
          :rules="[
            {
              required: true,
              message: ' name cannot be Empty.',

              trigger: 'blur',
            },
            {
              pattern: /^[a-zA-Z ]*$/,
              message: ' name must Contain Alpahbets only',

              trigger: 'blur',
            },
          ]"
        >
          <el-input
            placeholder="Search"
            v-model="search"
            class="rounded-none w-full"
          ></el-input>
        </el-form-item>
        <div class="absolute top-0 right-0 mt-2 mr-2">
          <feather-icon icon="SearchIcon" class="" />
        </div>
      </div>
    </div>
    <div class="mt-4">
      <el-table
        :data="elearnarticleData[0].paginatedresult"
        border
        style="width: 100%"
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-color"
      >
        <el-table-column
          :index="indexmethod"
          type="index"
          label="Sr.no"
          width="80"
        ></el-table-column>
        <el-table-column prop="city" label="ID" min-width="50px">
          <template v-slot="{ row }">
            <P class="text-gray"> {{ row.authorid }}</P>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="Author Name" min-width="50px">
          <template v-slot="{ row }">
            <P class="text-gray"> {{ row.name }}</P>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="Phone No." min-width="50px">
          <template v-slot="{ row }">
            <P class="text-gray"> {{ row.phone }}</P>
          </template>
        </el-table-column>

        <el-table-column prop="city" label="Actions" min-width="40px">
          <template v-slot="{ row }">
            <div
              class="flex gap-1 items-center"
              @click="handleupdate(false, row)"
              v-if="row.adminapproval == true"
            >
              <vs-button
                variant="primary"
                class="rounded-lg bg-danger border-0 text-white font-semibold py-2 px-8 sm-fsize14"
              >
                Reject
              </vs-button>
            </div>
            <div
              class="flex gap-1 items-center"
              @click="handleupdate(true, row)"
              v-if="row.adminapproval == false"
            >
              <vs-button
                variant="success"
                class="rounded-lg bg-success border-0 text-white font-semibold py-2 px-8 sm-fsize14"
              >
                Accept
              </vs-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      class="w-full flex justify-end mt-6"
      v-if="elearnarticleData[0].totalcount.length > 0"
    >
      <el-pagination
        pills
        :total="Number(elearnarticleData[0].totalcount[0].count)"
        layout="prev,pager,next"
        background
        :current-page="currentPage"
        @current-change="handlePageChange"
        size="sm"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import author from "../../../../../../Apicall/eLearning/author";
import { mapState } from "vuex";
export default {
  data() {
    return {
      currentPage: 1,
      offset: null,
      input: "",
      search: "",
      centerDialogVisibleg: false,
      form: {
        authorName: "",
        authorNumber: "",
        authorEmail: "",
        authorAbout: "",
        socialLinkedin: "",
        socialFacebook: "",
        socialTwitter: "",
        socialYoutube: "",
      },
    };
  },
  watch: {
    search() {
      this.GetAllauthor();
    },
  },
  computed: {
    ...mapState("eLearningAuthor", ["elearnarticleData"]),
  },
  methods: {
    handleclose() {
      this.$refs["form"].resetFields();
      this.centerDialogVisibleg = false;
      this.reset();
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    reset() {
      this.form.authorName = "";
      this.form.authorNumber = "";
      this.form.authorEmail = "";
      this.form.authorAbout = "";
      this.form.socialLinkedin = "";
      this.form.socialFacebook = "";
      this.form.socialTwitter = "";
      this.form.socialYoutube = "";
    },
    handleCategoryError(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return this.createAuthor();
        } else {
          return false;
        }
      });
    },
    async handleupdate(val, row) {
      const payload = {
        adminapproval: val,
        _id: row._id,
      };
      try {
        let data = await this.$store.dispatch(
          "eLearningAuthor/updateAuthor",
          payload
        );
        if (data.code == 200) {
          await this.GetAllauthor();
          this.getmessage("Record Updated", "success");
        }
      } catch (err) {}
    },
    getmessage(message, type) {
      this.$swal({
        text: message,
        icon: type,
        confirmButtonColor: "#cd3197",
        //confirmButtonColor: "#830c81",
        // cancelButtonColor: "#d33",
        confirmButtonText: "Okay",
      });
    },
    async handlePageChange(value) {
      this.currentPage = value;

      this.offset =
        this.currentPage > 1 ? (this.currentPage - 1) * 10 : this.currentPage;
      this.GetAllauthor();
    },
    async createAuthor() {
      this.centerDialogVisibleg = false;
      let payload = {
        name: this.form.authorName,
        phone: this.form.authorNumber,
        mail: this.form.authorEmail,
        aboutMe: this.form.authorAbout,
        linkedin: this.form.socialLinkedin,
        facebook: this.form.socialFacebook,
        twitter: this.form.socialTwitter,
        youtube: this.form.socialYoutube,
      };
      try {
        await this.$store.dispatch("eLearningAuthor/createAuthor", payload);
      } catch (error) {}
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    async GetAllauthor() {
      const payload = {};
      if (this.offset != null) {
        Object.assign(payload, { offset: this.offset });
      }
      if (this.search != "") Object.assign(payload, { search: this.search });
      try {
        await this.$store.dispatch("eLearningAuthor/getAllAuthor", payload);
      } catch (err) {}
    },
  },
  async mounted() {
    await this.GetAllauthor();
  },
};
</script>
